import { useEffect, useState } from 'react';
import Form from '../../../components/Form/Form';
import Select from '../../../components/Select/Select';
import { useAuth } from '../../../contexts/auth';
import './UrlPreference.css';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/Loader/Loader';
import { filterAllowedRoutes, routesData } from '../../../components/MenuBar/MenuBarIdentity';
import { mergeArraysFromItemFields } from '../../../utils/array';
import { useUserStore } from '../../../contexts/userStore';
import UserService from '../../../services/UserService';
import { useTranslation } from 'react-i18next';

export function UrlPreference(props) {
	const { user, storeUser, can } = useAuth();
	const { getUrlPreference } = useUserStore();
	const { licences, selectedLicenceObj } = useUserStore();
	const navigate = useNavigate();
	const [showLoader, setShowLoader] = useState(false);
	const [urlPreference, setUrlPreference] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		if (user.userData) {
			setUrlPreference(getUrlPreference());
		}
	}, [user, getUrlPreference])

	async function handleSubmitUrlPreference(event) {
		event.preventDefault();
		setShowLoader(true);
		const response = await UserService.updateUrlPreference(urlPreference);
		if (response.status === 200) {
			storeUser({
				userData: {
					...user.userData,
					urlPreference,
				}
			});
			NotificationManager.success("Tela inicial atualizada!", "", 2000);
			navigate(urlPreference);
		}
		setShowLoader(false);
	}

	return (
		<>
			{showLoader ? (
				<Loader style={{ marginTop: '0px' }} />
			) : (
				<Form
					handleSubmit={handleSubmitUrlPreference}
					navigateCancelUrl={getUrlPreference()}
				>
					<div className="edit-profile-url-preference-container">
						<p className="edit-profile-title-details">
							Escolha sua tela inicial
						</p>
						<Select
							labelText="Tela Inicial"
							name="url_preference"
							id="url_preference"
							value={urlPreference}
							onChange={({ target }) => setUrlPreference(target.value)}
							options={
								filterAllowedRoutes(
									user.userData,
									licences,
									selectedLicenceObj,
									mergeArraysFromItemFields(routesData, 'items'),
									can
								)
									.map(routeData => ({
										text: t(routeData.title),
										value: routeData.route.replace('..', ''),
									}))
							}
						/>
					</div>
				</Form>
			)}
		</>
	);
}